/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesAnotherActionAliases {
  AUTOC_ANOTHER_ACTION = 'autoc-another-action',
  CONTEXTUAL_BAR_ANOTHER_ACTION_MENU = 'contextual-bar-another-action-menu',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_ANOTHER_ACTION = 'fetch-another-action',
  FIELD_ANOTHER_ACTION = 'field-another-action',
  FIELD_DATE = 'field-date',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DEVICE = 'field-device',
  FIELDSET_DYNAMIC_FIELDS = 'fieldset-dynamic-fields',
  FORM_DEVICES_ANOTHER_ACTION_VIEWER = 'form-devices-another-action-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DATE = 'input-date',
  LAYOUT_DEVICES_ANOTHER_ACTION = 'layout-devices-another-action',
  MAPPER_ANOTHER_ACTION = 'mapper-another-action',
  PANEL_HEADER = 'panel-header',
  TEXT_ANOTHER_ACTION = 'text-another-action',
  TEXT_AREA_EVOLUTION_DESC = 'text-area-evolution-desc',
  TEXT_DEVICE = 'text-device',
}
export { DevicesAnotherActionAliases };
